<template>
    <div class="how-to">
        <div class="how-to__head">
            {{ getTranslatedText(`How to play`) }}
        </div>
        <div class="how-to__contents">
            <div
                v-for="(item, index) in listItems"
                :key="index"
                class="how-to__list-items"
                :class="{ active: item.isActive }"
            >
                <div
                    @click="handleToggleAnswer(index)"
                    class="how-to__list-item"
                >
                    <span v-html="getTranslatedText(item.title)" />
                    <img
                        v-if="!item.isActive && item.content"
                        class="how-to__list-item__title-icon-down"
                        src="@/assets/images/static-pages/dropdown-how-to.png"
                    />
                    <img
                        v-if="item.isActive && item.content"
                        class="how-to__list-item__title-icon-up"
                        src="@/assets/images/static-pages/icon-up-how-to.png"
                    />
                </div>
                <div v-if="item.isActive" class="how-to__list-item__content">
                    <div
                        v-for="(value, i) in item.content"
                        :key="i"
                        class="how-to__list-item__content__item"
                    >
                        <div class="how-to__list-item__content__item__left">
                            {{ value.step }}
                        </div>
                        <div class="how-to__list-item__content__item__right">
                            {{ value.text }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import languageMixin from "@/mixins/language/language-mixin";
export default {
    mixins: [languageMixin],
    components: {},
    data() {
        return {
            listItems: [
                {
                    title: "How to enter the draw?",
                    content: [
                        {
                            step: this.getTranslatedText("Step 1"),
                            text: this.getTranslatedText("Select your 7 numbers"),
                        },
                        {
                            step: this.getTranslatedText("Step 2"),
                            text: this.getTranslatedText(
                                `Click the button 'Buy your green certificate`
                            ),
                        },
                        {
                            step: this.getTranslatedText("Step 3"),
                            text: this.getTranslatedText(
                                "Complete the registration form"
                            ),
                        },
                        {
                            step: this.getTranslatedText("Step 4"),
                            text: this.getTranslatedText(
                                "Click continue to add more entries to increase your chances of winning"
                            ),
                        },
                        {
                            step: this.getTranslatedText("Step 5"),
                            text: this.getTranslatedText(
                                "Click continue to review your cart"
                            ),
                        },
                        {
                            step: this.getTranslatedText("Step 6"),
                            text: this.getTranslatedText("Click pay to confirm"),
                        },
                        {
                            step: this.getTranslatedText("Step 7"),
                            text: this.getTranslatedText(
                                "Complete the required payment details"
                            ),
                        },
                        {
                            step: this.getTranslatedText("Step 8"),
                            text: this.getTranslatedText("Click pay"),
                        },
                        {
                            step: this.getTranslatedText("Step 9"),
                            text: this.getTranslatedText(
                                "Download your green certificate"
                            ),
                        },
                    ],
                    isActive: true,
                },
                // {
                //     title: "How to manage cards?",
                //     content: [
                //         {
                //             step: this.getTranslatedText("Step 1"),
                //             text: this.getTranslatedText("Create an account"),
                //         },
                //         {
                //             step: this.getTranslatedText("Step 2"),
                //             text: this.getTranslatedText("Click manage cards"),
                //         },
                //         {
                //             step: this.getTranslatedText("Step 3"),
                //             text: this.getTranslatedText("Click add card"),
                //         },
                //         {
                //             step: this.getTranslatedText("Step 4"),
                //             text: this.getTranslatedText("Enter card details"),
                //         },
                //     ],
                //     isActive: false,
                // },
                {
                    title: this.getTranslatedText(
                        "How to add my favourite numbers?"
                    ),
                    content: [
                        {
                            step: this.getTranslatedText("Step 1"),
                            text: this.getTranslatedText("Create an account"),
                        },
                        {
                            step: this.getTranslatedText("Step 2"),
                            text: this.getTranslatedText("Click my numbers"),
                        },
                        {
                            step: this.getTranslatedText("Step 3"),
                            text: this.getTranslatedText("Click add favourite"),
                        },
                        {
                            step: this.getTranslatedText("Step 4"),
                            text: this.getTranslatedText("Select your 7 numbers"),
                        },
                        {
                            step: this.getTranslatedText("Step 5"),
                            text: this.getTranslatedText(
                                "Give your 7 numbers a name"
                            ),
                        },
                        {
                            step: this.getTranslatedText("Step 6"),
                            text: this.getTranslatedText(
                                "Save your selection for future use"
                            ),
                        },
                    ],
                    isActive: false,
                },
                {
                    title: "How to add credit?",
                    content: [
                        {
                            step: this.getTranslatedText("Step 1"),
                            text: this.getTranslatedText("Create an account"),
                        },
                        {
                            step: this.getTranslatedText("Step 2"),
                            text: this.getTranslatedText("Click my wallet"),
                        },
                        {
                            step: this.getTranslatedText("Step 3"),
                            text: this.getTranslatedText("Click add credit"),
                        },
                        {
                            step: this.getTranslatedText("Step 4"),
                            text: this.getTranslatedText("Enter amount"),
                        },
                        {
                            step: this.getTranslatedText("Step 5"),
                            text: this.getTranslatedText("Click add credit"),
                        },
                        {
                            step: this.getTranslatedText("Step 6"),
                            text: this.getTranslatedText(
                                "Select your credit card"
                            ),
                        },
                        {
                            step: this.getTranslatedText("Step 7"),
                            text: this.getTranslatedText(
                                "The amount will reflect in your wallet credit balance"
                            ),
                        },
                    ],
                    isActive: false,
                },
                {
                    title: "How to transfer credit?",
                    content: [
                        {
                            step: this.getTranslatedText("Step 1"),
                            text: this.getTranslatedText("Create an account"),
                        },
                        {
                            step: this.getTranslatedText("Step 2"),
                            text: this.getTranslatedText("Click my wallet"),
                        },
                        {
                            step: this.getTranslatedText("Step 3"),
                            text: this.getTranslatedText(
                                "Click transfer/withdraw balance"
                            ),
                        },
                        {
                            step: this.getTranslatedText("Step 4"),
                            text: this.getTranslatedText(
                                "Select an option. Bank transfer or to a mobile number/email"
                            ),
                        },
                        {
                            step: this.getTranslatedText("Step 5"),
                            text: this.getTranslatedText(
                                "Submit the credit transfer form to successfully transfer credit"
                            ),
                        },
                    ],
                    isActive: false,
                },
                {
                    title: "How to select the right type of card for payment",
                    content: [
                        {
                            step: this.getTranslatedText("Step 1"),
                            text: this.getTranslatedText("Check if you have an Omani Debit card or any other card"),
                        },
                        {
                            step: this.getTranslatedText("Step 2"),
                            text: this.getTranslatedText("Select the correct option"),
                        },
                    ],
                    isActive: false,
                },
                // {
                //     title: "om_thawani_payment_text",
                //     isActive: false,
                // },
            ],
        };
    },
    methods: {
        handleToggleAnswer(index) {
            this.listItems.forEach((item, i) => {
                if (i === index) {
                    item.isActive = !item.isActive;
                }
            });
        },
    },
};
</script>

<style scoped lang="scss" src="@/assets/scss/mobile/static-pages/howto.scss" />
